module.exports = __webpack_public_path__ + "static/media/ic-profile-black.ae0b3702.svg";